import script from "./HolidayGantt.vue?vue&type=script&setup=true&lang=js"
export * from "./HolidayGantt.vue?vue&type=script&setup=true&lang=js"

import "./HolidayGantt.vue?vue&type=style&index=0&id=63f7f90e&scoped=true&lang=scss"
import "./HolidayGantt.vue?vue&type=style&index=1&id=63f7f90e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f7f90e"]])

export default __exports__